/*
 * File: ui-relation-connect.ts
 * File Created: 2024-02-19 08:51:06
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-11-18 03:07:58
 * Modified By: Val Liu
 * -----
 */

import {
    BaseUITag,
    EUITagRuleType,
    EUITagRuleUnion,
    EUITagTarget,
    IUITagInput,
    IUITagResult,
    UITag,
} from "../core";

// @uiRelationConnect - Auto disconnect / connect on relation.

@UITag.set()
export class uiRelationConnect extends BaseUITag {
    appliedTo: EUITagTarget[] = [EUITagTarget.FormSubmit];
    ruleTypes: EUITagRuleUnion[] = [EUITagRuleType.Boolean];
    allowNullRule: boolean = true;

    /// set prop sortable: true / false
    parse(input: IUITagInput): IUITagResult {
        /// default: true
        /// rule: true / false
        const rule = Boolean(this.parseRule(input) ?? true);

        return {
            specials: {
                relationConnect: rule,
            },
        };
    }
}
